export enum VersionType {
  Installed = 'versionInstalled',
  Downloaded = 'versionDownloaded',
}
